// Every image in src/images/cases, sorted by filename. Add or remove files there to change
// the home page marquee and the Cases page gallery.
const imageContext = require.context('../images/cases', false, /\.(png|jpe?g|webp|svg)$/i);

export const caseImages: string[] = imageContext.keys().sort().map((key) => imageContext(key));

export const CASES_SUBTITLE = "Check out some high-profile cases Joe Wells has defended.";
